module.exports = __webpack_public_path__ + "static/media/joegray-headshot.be4476b8.jpg";